<mat-form-field [appearance]="appearance">
    <mat-label *ngIf="placeholder">{{ placeholder }}</mat-label>
    <textarea
        type="text"
        (change)="inputChange($event)"
        autocomplete="off"
        matInput
        [rows]="rows"
        [name]="name"
        [title]="title || ''"
        [id]="id"
        [class]="computedClassList"
        [formControl]="control"
        [errorStateMatcher]="matcher"
        [debounce]="debounceValue"
        (eventHandler)="debounceEventHandler.emit($event)"
        (keyup)="keyUpEventHandler.emit($event)"
        (keypress)="errors && errors.splice(0, 1)"></textarea>
    <material-button
        *ngIf="control.value && control.value.length > 0 && disabled !== true && needIcon && !(errors && errors.length > 0)"
        matSuffix
        buttonType="icon"
        prefixIcon="done"
        prefixIconType="material"
        color="default"
        size="small"></material-button>
    <material-button
        *ngIf="description && description.length > 0"
        matSuffix
        buttonType="icon"
        prefixIcon="info"
        prefixIconType="material"
        color="default"
        size="small"
        [titleText]="description"></material-button>

    <mat-hint align="end" *ngIf="maxLength">
        <span [textContent]="characterCount"></span>
        /
        <span [textContent]="maxLength"></span>
    </mat-hint>
    <mat-hint align="start" *ngIf="required && !(errors && errors.length > 0)">
        <strong>
            <span>*</span>
            Required
        </strong>
    </mat-hint>
    <mat-hint align="start" *ngIf="!required && !(errors && errors.length > 0) && hint && hint.length > 0">
        <span [textContent]="hint"></span>
    </mat-hint>
    <mat-error *ngIf="errors && errors.length > 0" [title]="errors">
        <span [textContent]="errors"></span>
    </mat-error>
</mat-form-field>
